.selectCell {
	display: flex;
	align-items: center;
	justify-content: center;
}

.oaCard {
	display: flex;
	flex-direction: column;
	gap: 0.3rem;
	padding: 0.55rem 0.6rem;
	border: 1px solid #e5e7eb;
	border-radius: 12px;
	background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
}

.oaCode {
	font-size: 1rem;
	font-weight: 800;
	color: #111827;
	line-height: 1.1;
}

.oaBadges {
	display: flex;
	align-items: center;
	gap: 0.35rem;
	flex-wrap: wrap;
}

.oaInternalCode {
	font-size: 0.72rem;
	color: #4b5563;
	line-height: 1.3;
}

.oaField {
	font-weight: 600;
	color: #1f2937;
}

.centerCard {
	display: flex;
	flex-direction: column;
	gap: 0.2rem;
	padding: 0.35rem 0.45rem;
	border: 1px solid #e5e7eb;
	border-radius: 8px;
	background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
	min-width: 0;
	flex: 1 1 45%;
	max-width: 100%;
}

.centerHeader {
	display: flex;
	align-items: center;
	gap: 0.35rem;
	font-size: 0.72rem;
	font-weight: 700;
	color: #475569;
	text-transform: uppercase;
	letter-spacing: 0.03em;
}

.centerName {
	display: flex;
	align-items: center;
	gap: 0.35rem;
	font-size: 0.82rem;
	font-weight: 700;
	color: #111827;
}

.centerMeta {
	display: flex;
	gap: 0.35rem;
	flex-wrap: wrap;
}

.numericRight {
	width: 100%;
	text-align: right;
}

.alignCenter {
	display: flex;
	align-items: center;
}

.actionsHeader {
	width: 100%;
	text-align: center;
}

.actionsCell {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	min-height: 100%;
}
